module.exports = __webpack_public_path__ + "img/diagram.1d1dbb3a.svg";